<template>
  <div class="recharge-page">
    <van-nav-bar
      class="recharge-nav"
      title="存款"
      left-arrow
      @click-left="$router.back()"
    />

    <main class="recharge-content">
      <div class="recharge-methods">
        <button class="method-item active" type="button">
          <span class="usdt-icon method-icon">₮</span>
          <span>USDT充值</span>
        </button>
        <button class="method-item" type="button" @click="openKefu">
          <span class="service-icon">人</span>
          <span>联系人工</span>
        </button>
      </div>

      <section class="recharge-card">
        <div class="balance-panel">
          <div>
            <div class="balance-label">当前余额</div>
            <div class="balance-value"><span>¥</span>{{ balance }}</div>
          </div>
        </div>

        <div class="section-title">充值币种</div>
        <div class="currency-list">
          <div class="currency-item active">
            <span class="usdt-icon">₮</span>
            <span>USDT</span>
          </div>
        </div>

        <div class="deposit-tip">扫码或使用以下地址完成存款</div>

        <div class="deposit-main">
          <div class="qrcode-box">
            <div ref="usdtQrcode" class="qrcode"></div>
            <span v-if="!usdtAddress" class="qrcode-empty">
              {{ usdtAddressLoading ? '加载中' : '暂无地址' }}
            </span>
          </div>

          <div class="minimum-info">
            <div class="minimum-label">最小充值金额</div>
            <div class="minimum-value">{{ min_price }} USDT</div>
          </div>
        </div>

        <button class="address-box" type="button" @click="copyUsdtAddress">
          <span class="address-text">{{ usdtAddress || '正在获取充值地址...' }}</span>
          <span class="copy-icon" aria-label="复制">
            <i></i><i></i>
          </span>
        </button>

        <div class="network-tip">仅支持 TRC20 网络，请勿使用其他网络充值</div>
      </section>

      <div class="recharge-actions">
        <button class="action-button primary" type="button" @click="confirmRecharge">我已充值</button>
        <button class="action-button secondary" type="button" @click="openRechargeRecords">充值记录</button>
      </div>

      <section class="notice-card">
        <div class="notice-title"><span class="notice-icon">i</span>温馨提示</div>
        <ul class="notice-list">
          <li><strong>收款地址定期更换，请勿保存作为长期使用</strong>，付款前请确认与系统展示是否一致。</li>
          <li>请勿向上述地址充值任何<strong>非选项中提供的网络协议和充值币种</strong>，否则资产将不可找回。</li>
          <li>您充值至上述地址后，需要整个网络节点的确认，2次网络确认后到账。1~5分钟内到账</li>
          <li>您充值至上述地址后，若长时间没到账，可以点击“我已充值”，进行同步充值数据。</li>
          <li>请务必确认电脑及浏览器安全，防止信息被篡改或泄漏。</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  name: 'RechargeUsdt',
  data() {
    return {
      pay_way: 'usdt',
      meyXi: 'TRC20',
      min_price: '10.00',
      balance: '0.00',
      usdtAddress: '',
      usdtAddressLoading: false,
      usdtQrCode: null,
      unsubscribeStore: null,
    };
  },
  created() {
    this.syncBalanceFromCache();
    this.getUsdtAddress();
    this.getPayRange();
  },
  methods: {
    getUsdtAddress() {
      if (this.usdtAddressLoading) return;

      const routeAddress = this.$route && this.$route.query
        ? this.$route.query.address
        : '';
      if (routeAddress) {
        this.setUsdtAddress(routeAddress);
        return;
      }

      this.usdtAddressLoading = true;
      this.$apiFun
        .post('/api/user', {})
        .then(res => {
          if (Number(res.code) === 200) {
            const data = res.data || {};
            this.setUsdtAddress(data.wallet_address || '');
            if (data.balance !== undefined && data.balance !== null) {
              this.setBalance(data.balance);
            }
          } else {
            this.setUsdtAddress('');
            this.showTost(0, res.message || '获取充值地址失败');
          }
        })
        .catch(error => {
          console.error('获取USDT充值地址失败：', error);
          this.setUsdtAddress('');
          this.showTost(0, '获取充值地址失败');
        })
        .finally(() => {
          this.usdtAddressLoading = false;
        });
    },
    getPayRange() {
      this.$apiFun
        .post('/api/getPayRange', { type: 'usdt-trc20' })
        .then(res => {
          if (Number(res.code) === 200 && res.data && res.data.min_price !== undefined) {
            this.min_price = Number(res.data.min_price).toFixed(2);
          }
        });
    },
    setUsdtAddress(address) {
      this.usdtAddress = String(address || '').trim();
      this.$nextTick(this.createUsdtQRCode);
    },
    createUsdtQRCode() {
      const element = this.$refs.usdtQrcode;
      if (!element) return;
      element.innerHTML = '';
      this.usdtQrCode = null;
      if (!this.usdtAddress) return;

      this.usdtQrCode = new QRCode(element, {
        text: this.usdtAddress,
        width: 116,
        height: 116,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
      this.$apiFun
        .post('/api/get/usdt/pay', { type: 'usdt-trc20' })
        .then(res => {
          if (Number(res.code) === 200) {
                          
          }
        });
    },
    copyUsdtAddress() {
      if (!this.usdtAddress) {
        this.showTost(0, '暂无可复制的充值地址');
        return;
      }
      this.doCopy(this.usdtAddress);
    },
    doCopy(value) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value).then(() => {
          this.showTost(1, '复制成功！');
        });
        return;
      }
      const input = document.createElement('input');
      input.value = value;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showTost(1, '复制成功！');
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    openKefu() {
      this.$parent.openKefu();
    },
    confirmRecharge() {
      if (!this.usdtAddress) {
        this.showTost(0, '充值地址尚未加载完成');
        return;
      }

      this.$apiFun
        .post('/api/get/usdt/pay', { type: 'usdt-trc20' })
        .then(res => {
          if (Number(res.code) === 200) {
              this.showTost(1, '已提交，到账后系统将自动确认');            
          }
        });
      
    },
    openRechargeRecords() {
      this.$router.push({ path: '/transRecord' });
    },
    setBalance(value) {
      const number = Number(value);
      this.balance = Number.isFinite(number) ? number.toFixed(2) : '0.00';
    },
    syncBalanceFromCache() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if (userInfo.balance !== undefined && userInfo.balance !== null) {
          this.setBalance(userInfo.balance);
        }
      } catch (error) {
        console.warn('读取用户余额缓存失败：', error);
      }
    },
  },
  mounted() {
    if (this.$store && typeof this.$store.subscribe === 'function') {
      this.unsubscribeStore = this.$store.subscribe(mutation => {
        if (mutation.type === 'changUserInfo') this.syncBalanceFromCache();
      });
    }
  },
  beforeDestroy() {
    if (this.$refs.usdtQrcode) this.$refs.usdtQrcode.innerHTML = '';
    this.usdtQrCode = null;
    if (typeof this.unsubscribeStore === 'function') this.unsubscribeStore();
    this.unsubscribeStore = null;
  },
};
</script>

<style lang="scss" scoped>
.recharge-page {
  width: 100%;
  min-height: 100vh;
  background: #edf1ff;
  color: #17213c;
}

.recharge-nav {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
}

.recharge-content {
  box-sizing: border-box;
  padding: 58px 12px 24px;
}

.recharge-card {
  max-width: 520px;
  margin: 0 auto;
  padding: 18px 16px 14px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(56, 77, 130, 0.05);
}

.recharge-methods {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  max-width: 520px;
  margin: 0 auto 12px;
}

.method-item {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 48px;
  border: 1px solid #dce2ee;
  border-radius: 12px;
  background: #ffffff;
  color: #59657d;
  font-size: 15px;
  box-shadow: 0 5px 15px rgba(56, 77, 130, 0.04);
}

.method-item.active {
  border-color: #3479ff;
  color: #286cff;
  background: #f4f8ff;
}

.method-icon {
  width: 22px !important;
  height: 22px !important;
}

.service-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-right: 7px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 12px;
  background: #7d8ba8;
}

.section-title,
.deposit-tip {
  font-size: 15px;
  line-height: 22px;
}

.balance-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 17px;
  padding: 13px 15px;
  border-radius: 12px;
  color: #ffffff;
  background: linear-gradient(135deg, #347fff, #316cf3);
  box-shadow: 0 7px 16px rgba(49, 108, 243, 0.22);
}

.balance-label {
  font-size: 13px;
  opacity: 0.85;
}

.balance-value {
  margin-top: 3px;
  font-size: 25px;
  font-weight: 600;
  line-height: 30px;
}

.balance-value span {
  margin-right: 3px;
  font-size: 15px;
}

.currency-list {
  display: flex;
  margin: 9px 0 12px;
}

.currency-item {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 16px 0 11px;
  border-radius: 22px;
  color: #ffffff;
  font-size: 15px;
  background: linear-gradient(135deg, #337dff, #396cf5);
  box-shadow: 0 5px 12px rgba(51, 115, 255, 0.35);
}

.usdt-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  margin-right: 7px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  background: #27b897;
}

.deposit-main {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.qrcode-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 134px;
  height: 134px;
  border: 7px solid #f3f5f9;
  border-radius: 13px;
  background: #ffffff;
  box-sizing: border-box;
}

.qrcode,
.qrcode ::v-deep img,
.qrcode ::v-deep canvas {
  display: block !important;
  width: 116px !important;
  height: 116px !important;
}

.qrcode-empty {
  position: absolute;
  color: #9aa4b8;
  font-size: 13px;
}

.minimum-info {
  margin-left: 18px;
  font-size: 13px;
  line-height: 22px;
}

.minimum-label {
  color: #72809e;
}

.minimum-value {
  color: #0ebd5b;
}

.address-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  margin-top: 12px;
  padding: 0 15px;
  border: 1px solid #d9dee9;
  border-radius: 24px;
  background: #ffffff;
  color: #1a2949;
  text-align: left;
}

.address-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-family: monospace;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.copy-icon {
  position: relative;
  width: 18px;
  height: 18px;
  margin-left: 8px;
}

.copy-icon i {
  position: absolute;
  width: 9px;
  height: 9px;
  border: 2px solid #7b849b;
  border-radius: 1px;
}

.copy-icon i:first-child {
  top: 2px;
  left: 2px;
}

.copy-icon i:last-child {
  right: 1px;
  bottom: 1px;
  background: #ffffff;
}

.network-tip {
  margin-top: 10px;
  color: #a0a8b8;
  font-size: 12px;
  text-align: center;
}

.recharge-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-width: 520px;
  margin: 12px auto 0;
}

.action-button {
  height: 44px;
  border-radius: 22px;
  font-size: 15px;
}

.action-button.primary {
  border: 1px solid #3479ff;
  color: #ffffff;
  background: linear-gradient(135deg, #3986ff, #316cf3);
  box-shadow: 0 6px 14px rgba(49, 108, 243, 0.25);
}

.action-button.secondary {
  border: 1px solid #3479ff;
  color: #3479ff;
  background: #ffffff;
}

.notice-card {
  box-sizing: border-box;
  max-width: 520px;
  margin: 12px auto 0;
  padding: 13px 16px 14px;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(56, 77, 130, 0.04);
}

.notice-title {
  display: flex;
  align-items: center;
  color: #27334e;
  font-size: 14px;
  line-height: 22px;
}

.notice-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  margin-right: 5px;
  border: 1px solid #53617c;
  border-radius: 50%;
  font-family: serif;
  font-size: 10px;
  line-height: 1;
}

.notice-list {
  margin: 6px 0 0;
  padding-left: 22px;
  color: #27334e;
  font-size: 13px;
  line-height: 20px;
}

.notice-list li + li {
  margin-top: 2px;
}

.notice-list strong {
  color: #ff2d2d;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue